export enum Locale {
  deDE = 'de-DE',
  enGB = 'en-GB',
}
